module.exports = __webpack_public_path__ + "media/logo/gold-on-black-wide-e78d4801.png";